const BRANDS = ['FreeTaxUSA', 'TaxHawk', 'Express1040']

// Read at call time. Callers are imported before the router writes appName, and a
// branch preview leaves it the string 'undefined' — neither may reach a host or a link.
const getBrandName = () => {
	const appName = sessionStorage.getItem('appName')
	return BRANDS.includes(appName) ? appName : BRANDS[0]
}

export default getBrandName